export default interface MenuInterface {
    id: number;
    n: string;
    img?: string | null;
    i?: string | null;
    url: string;
    itm?: MenuInterface[];
}

export enum MenuKeys {
    name = 'n',
    image = 'img',
    icon = 'i',
    items = 'itm'
}
